<script>
    import gsap from 'gsap';
    import DrawSVGPlugin from 'gsap/DrawSVGPlugin';
    import {onMount, onDestroy} from "svelte";

    gsap.registerPlugin(DrawSVGPlugin);

    let displayNum = 0;

    function interpolate(start, target, durationMS) {
        if (start === target) {
            return;
        }

        const steps = target - start;
        const frameDuration = durationMS / steps;
        const newStart = start + 1;

        displayNum = newStart;

        setTimeout(() => interpolate(newStart, target, durationMS - frameDuration), frameDuration);
    }

    let drawLine;
    let tl = gsap.timeline();
    let svgElement;

    onMount(() => {
        tl.fromTo(drawLine, {
            drawSVG: "100% 100%",
            transformOrigin: 'center center',
        }, {
            drawSVG: "100% 0%",
            stagger: 0.15,
            duration: 1,
            onStart: () => {
                interpolate(0, 30, 1000)
            },
        });

        tl.play();
    });

    onDestroy(() => {
        tl.clear();
        tl = null;
    })
</script>

<svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 380 678" bind:this={svgElement}>
    <defs>
        <clipPath id="clip-path">
            <rect id="Rectangle_593" data-name="Rectangle 593" width="104.043" height="133.88" fill="none"/>
        </clipPath>
    </defs>
    <rect id="Rectangle_867" data-name="Rectangle 867" width="380" height="678"/>
    <text id="Who_is_involved_" data-name="Who is involved?" transform="translate(38 50.446)" fill="#fcd0b1"
          font-size="24" font-family="Metric">
        <tspan x="0" y="0">Who is involved?</tspan>
    </text>
    <text id="CHRO" transform="translate(38 100)" fill="#fff" font-size="86" font-family="Metric-Bold, Metric"
          font-weight="700">
        <tspan x="0" y="66">CHRO</tspan>
    </text>
    <text id="_30_" data-name="30%" transform="translate(90 287)" fill="#fff" font-size="86"
          font-family="Metric-Bold, Metric" font-weight="700">
        <tspan x="11.937" y="66">{displayNum}%</tspan>
    </text>
    <g id="Group_1187" data-name="Group 1187" transform="translate(173 229)">
        <g id="Group_1186" data-name="Group 1186" clip-path="url(#clip-path)">
            <path bind:this={drawLine} id="Path_14595" data-name="Path 14595"
                  d="M6.615,6.653a96.429,96.429,0,0,1,96.429,96.429,91.655,91.655,0,0,1-4.72,29.8" fill="none"
                  stroke="#008ed2" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path id="Path_14596" data-name="Path 14596" d="M1.2,6.6A5.4,5.4,0,1,1,6.6,12,5.4,5.4,0,0,1,1.2,6.6"
                  fill="#fff"/>
            <path id="Path_14597" data-name="Path 14597" d="M1.2,6.6A5.4,5.4,0,1,1,6.6,12,5.4,5.4,0,0,1,1.2,6.6Z"
                  fill="none" stroke="#100f0c" stroke-miterlimit="10" stroke-width="2.398"/>
        </g>
    </g>
    <text id="of_companies_say_the_chief_human_resources_officer_is_frequently_involved_in_making_strategic_decisions"
          data-name="of companies say the chief human resources officer is frequently involved in making strategic decisions"
          transform="translate(38 429)" fill="#fff" font-size="24" font-family="Metric">
        <tspan x="0" y="18">of companies say the</tspan>
        <tspan x="0" y="46">chief human resources</tspan>
        <tspan x="0" y="74">officer is frequently</tspan>
        <tspan x="0" y="102">involved in making</tspan>
        <tspan x="0" y="130">strategic decisions</tspan>
    </text>
</svg>
